import React, { useState, useRef, useEffect } from "react";
import { Box, FormControl, Select, MenuItem, ListSubheader } from "@mui/material";
import { Form, Input } from "antd";
import { useLocation } from "react-router-dom";
import GenericModal from "../buttons/genericModal";
import { backendPostWithoutRefresh } from "../../helpers/callBackend";
import AddTeammatesEmails from "../specific/company/team/addTeammatesEmails";
import { cancelPreviousPageRequests } from "../../helpers/callBackend";
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';

const CompanySelect = ({ companiesData, currentCompany, handleCompanyChange, MenuProps, addCompanyToDropdown }) => {
  const [visible, setVisible] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const formRef = useRef(null);

  const location = useLocation();

  const onFormSubmitModal = (values) => {
    cancelPreviousPageRequests(location.pathname);
    setSubmitting(true);
    const data = {
      ...values,
      is_active: true,
    };
    backendPostWithoutRefresh("/api/landlord/", data)
      .then((res) => {
        const companyData = res.data.landlord_instances;
        localStorage.setItem("arpariCompanyListData", JSON.stringify(companyData));
        addCompanyToDropdown(companyData);
        setVisible(false);
      })
      .catch(() => {
        setSubmitting(false);
      });
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <FormControl fullWidth>
        <Select
          MenuProps={MenuProps}
          sx={{
            width: 300,
            height: 36,
            alignItems: 'center',
          }}
          displayEmpty
          renderValue={(selected) => {
            if (!selected || selected.length === 0) {
              return <em style={{ color: 'rgba(0, 0, 0, 0.6)' }}>{currentCompany?.company_name}</em>;
            }
            return selected?.company_name;
          }}
        >
          {companiesData.map((company, index) => (
            <MenuItem
              onClick={() => handleCompanyChange(company)}
              key={index}
              value={company}
              sx={{ fontSize: 12 }}
            >
              {company.company_name}
            </MenuItem>
          ))}
          <ListSubheader>
            <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                <Button
                    disableElevation
                    fullWidth
                    size="small"
                    variant="outlined"
                    color="secondary"
                    sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                    onClick={() => setVisible(true)}
                >
                    + Add New Company
                </Button>
            </Box>
          </ListSubheader>
        </Select>
      </FormControl>
      <GenericModal
        size="md"
        visible={visible}
        handleCancelModal={() => setVisible(false)}
        showModal={() => setVisible(true)}
        modalTitle={"Add New Company"}
        modalBody={
          <Form
            layout="vertical"
            name="basic"
            onFinish={onFormSubmitModal}
            autoComplete="off"
            ref={formRef}
          >
            <Form.Item
                label="Company Name"
                name="company_name"
                rules={[
                    {
                      required: true,
                      message: "Please input company name!",
                    },
                ]}
            >
            <Input placeholder="Company Name" />
            </Form.Item>
                <AddTeammatesEmails minimumEmailsRequired={0} />
            <Form.Item>
                <LoadingButton
                    htmlType="submit"
                    loading={submitting}
                    loadingPosition="start"
                    style={{ margin: "3px", width: "100%" }}
                    disableElevation
                    fullWidth
                    size="small"
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                  >
                    Submit
                  </LoadingButton>
                </Form.Item>
            </Form>
            }
        />
    </Box>
  );
};

export default CompanySelect;
